<template>
    <v-container fluid fill-height>

        <NavigationDrawer @onRouteUpdate="updatePopupContent" v-if="drawer"/>

        <v-layout>

            <!--div fill-height-->

            <MatchingFocusPoints v-if="matchingFocusPointsDialog"/>
            <EditCheckpoint v-if="showEditCheckpointDialog"/>

            <l-map ref="map" id="map" :zoom="zoom" :center="center">

                <l-tile-layer :url="url" :attribution="attribution">
                </l-tile-layer>


            </l-map>

            <!--/div-->
        </v-layout>
    </v-container>
</template>


<script>

    import {LMap, LTileLayer, LMarker, LLayerGroup, LPolyline, LFeatureGroup, LTooltip} from 'vue2-leaflet';
    //import Vue2LeafletRotatedMarker from 'vue2-leaflet-rotatedmarker'
    import {setRoute} from '../../tools/';


    import MatchingFocusPoints from './MatchingFocusPoints'
    import EditCheckpoint from './forms/EditCheckpoint';
    import SelectedLocation from './SelectedLocation'
    import NavigationDrawer from './NavigationDrawer'

    //import LocationMarker from './LocationMarker'
    import 'leaflet-draw'
    import 'leaflet-rotatedmarker'
    import 'leaflet-geometryutil'
    import 'leaflet-snap';
    //import 'leaflet.geometryutil.js'


    export default {
        components: {
            LMap,
            LTileLayer,
            LMarker,
            LLayerGroup,
            MatchingFocusPoints,
            LPolyline,
            LTooltip,
            SelectedLocation,
            LFeatureGroup,
            NavigationDrawer,
            EditCheckpoint
        },
        name: 'RoutesIndex',

        data() {
            // [66.5, 25.7]
            return {
                hideDrawingTools: false,
                style: "",
                activeGroup: undefined,
                editMode: false,
                deleteMode: false,
                drawMode: false,
                editableFeatureGroup: undefined,
                drawControl: undefined,
                map: undefined,
                locationsFeatureGroup: undefined,
                routesFeatureGroup: undefined,
                selected: undefined,
                resizeMap: undefined,
                closePopupOnMouseout: false,
                cannotDeleteGroup: undefined,
                cannotMoveGroup: undefined,
                updateLocationMarker: undefined,
                redrawnLines: [],
                routeIcon: window.L.icon({
                    iconUrl: 'marker-icon_route.png',
                    popupAnchor: [0, -40], // point from which the popup should open relative to the iconAnchor
                    iconSize: [25, 41], // size of the icon
                    iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
                }),

                routeIconRemoved: window.L.icon({
                    iconUrl: 'marker-icon_grey_route.png',
                    popupAnchor: [0, -40], // point from which the popup should open relative to the iconAnchor
                    iconSize: [25, 41], // size of the icon
                    iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
                }),

                checkPointIcon: window.L.icon({
                    iconUrl: 'marker-icon_checkpoint.png',
                    popupAnchor: [0, -40], // point from which the popup should open relative to the iconAnchor
                    iconSize: [25, 41], // size of the icon
                    iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
                }),

                checkPointIconRemoved: window.L.icon({
                    iconUrl: 'marker-icon_grey_checkpoint.png',
                    popupAnchor: [0, -40], // point from which the popup should open relative to the iconAnchor
                    iconSize: [25, 41], // size of the icon
                    iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
                }),


                url: "http://tiles.kartat.kapsi.fi/peruskartta/{z}/{x}/{y}.jpg",
                //center: L.latLng(66.5, 25.7),
                //url:'http://geo.plab.fi/geoserver/gwc/service/wmts?layer=cite:Maastokartta&style=&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image/png&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}',
                attribution: '&copy; <a href="http://osm.org/copyright">Maanmittauslaitos</a> contributors',
                marker: window.L.latLng(66.5, 25.7),
                closestMarkers: [],
                //leafLetlines: [],
                //touchIcons: [],


            }
        },

        beforeRouteLeave(to, from, next){
            
      this.$store.commit('checkpoints/setEditTask', false)
      this.$store.commit('checkpoints/setShowEditCheckpointDialog', false)
      this.$store.commit('routes/cleanEditableFeature', undefined)
      this.$store.commit('routes/flushFeatureEditable', undefined)
      next()

    },



        created() {

            this.$store.dispatch('settings/setShowOnlyHidden', true)

            
            window.vm.$on('updateMarkerPositionAfterLatLngUpdated', (data) => {
                const {element, lat, lng, startMoved} = data;
               
                if(this.attachMarkerToNode)
                {
                    
                    let movedMarker = this.locationsFeatureGroup.getLayer(element.leafletid);
                    if (movedMarker) {
                                   
                        this.$store.dispatch('lines/closestLines', movedMarker).then(() => {
                            let closestLineLayers = this.$store.getters['lines/closestLines']
                            let closestLines = []
                           
                           
                            try {
                                Object.keys(closestLineLayers).forEach((cl) => {
                                    let closestLine = this.activeGroup.getLayer(cl);
                                  


                                    closestLineLayers[cl].forEach((i) => {
                                        let latlng = new window.L.latLng(lat, lng)
                                        closestLine._latlngs[i] = latlng
                                        closestLines.push(closestLine);
                                       

                                    })

                                   

                                   

                                   


                                })

                                

                                 this.$store.dispatch('lines/updateLinesAfterLatLngUpdate', closestLines).then(() => {

                                        
                                        if(startMoved === true)
                                        {
                                    
                                            let routeid = this.route._id;

                                            let route = this.$store.getters['routes/index'].find((r) => {
                                                return r._id == routeid;
                                            })


                                            if(route)
                                            {
                                                //route.focusPoint.coordinates = start.location.newGeometry.coordinates;
                                                //route = {...route}
                                                
                                                //this.$store.commit('routes/updateRoutePos', routeFromRoutes)

                                                let routeMarker = this.routesFeatureGroup.getLayer(route.leafletid);
                                                if(typeof routeMarker !== 'undefined')
                                                {
                                                    let latlng = new window.L.latLng(lat, lng)
                                                    routeMarker.setLatLng(latlng)
                                                }
                                                
                                                setRoute(
                                                    //this.$store.getters['routes/selectedMarker'],
                                                    this.$store.getters['routes/route'],
                                                    this.$store,
                                                    true
                                                )
                                                
                                                
                                            }
                                        } else {
                                            
                                            setRoute(
                                                    //this.$store.getters['routes/selectedMarker'],
                                                    this.$store.getters['routes/route'],
                                                    this.$store,
                                                    true
                                                )
                                        }

                                 }).catch(() => {
                                     
                                    /*setRoute(
                                        //this.$store.getters['routes/selectedMarker'],
                                        this.$store.getters['routes/route'],
                                        this.$store,
                                        true
                                    )*/
                                 })

                                



                            } catch (err) {
                                
                            }




                        }).catch(() => {})
                    }
                    

                    
                } else {
                    
                    if(startMoved === true)
                    {
                    
                        let routeid = this.route._id;

                        let route = this.$store.getters['routes/index'].find((r) => {
                            return r._id == routeid;
                        })


                        if(route)
                        {
                            //route.focusPoint.coordinates = start.location.newGeometry.coordinates;
                            //route = {...route}
                            
                            //this.$store.commit('routes/updateRoutePos', routeFromRoutes)

                            let routeMarker = this.routesFeatureGroup.getLayer(route.leafletid);
                            if(typeof routeMarker !== 'undefined')
                            {
                                let latlng = new window.L.latLng(lat, lng)
                                routeMarker.setLatLng(latlng)
                            }
                            
                            setRoute(
                                //this.$store.getters['routes/selectedMarker'],
                                this.$store.getters['routes/route'],
                                this.$store,
                                true
                            )

                            
                        }
                    } else {
                        //
                        setRoute(
                                //this.$store.getters['routes/selectedMarker'],
                                this.$store.getters['routes/route'],
                                this.$store,
                                true
                            )
                    }
                }
            })




            window.L.EditToolbar.Delete.include({
                removeAllLayers: false
            })

            window.vm.$on('restoreRoute', (route) => {

                 this.showSelectedLocationDialog = false;
                 this.drawer = false;
                 this.$store.dispatch('drawer/setFormAddRoute')
                 //let destroyPromise = this.$store.dispatch('routes/destroy', hardDelete)
                 let restorePromise = this.$store.dispatch('routes/restore', route)
               
                this.afterRouteDestroy(restorePromise, true);
            

                this.$store.dispatch('status/updateResources', 'routedata')

            })


            window.vm.$on('routeGroupUpdated', () => {

                //console.log("########## ON ROUTEGROUPUPDATED")

                //this.showSelectedLocationDialog = false;
                //this.drawer = false;
                //this.$store.dispatch('drawer/setFormAddRoute')
                



                this.afterRouteUpdate(false)
                this.$store.dispatch('status/updateResources', 'routedata')

                //window.vm.$emit('routeNameUpdated')
            });

            window.vm.$on('routeUpdated', () => {
                /*console.log("######### routeUpdated")
                this.showSelectedLocationDialog = false;
                this.drawer = false;
                this.$store.dispatch('drawer/setFormAddRoute')
                this.afterRouteUpdate();*/

                //console.log("###### route updated", this.$store.getters['routes/route'])
                //this.$store.dispatch('routes/setSelectedMarker', )
            
                    setRoute(
                        //this.$store.getters['routes/selectedMarker'],
                        this.$store.getters['routes/route'],
                        this.$store
                    )

                    this.$store.dispatch('status/updateResources', 'routedata');
               
            });

            

           /* window.vm.$on('routeNameUpdated', () => {

                console.log("dsflkdjsflkdsf")

                if(typeof this.map !== 'undefined')
                {
                    if(typeof this.drawControl !== 'undefined')
                    {
                        this.map.removeControl(this.drawControl)
                        this.drawControl = undefined
                    }
                }
                this.init();

                setRoute(
                    //this.$store.getters['routes/selectedMarker'],
                    this.$store.getters['routes/route'],
                    this.$store
                )

                this.$store.dispatch('status/updateResources', 'routedata');
            })*/

            window.vm.$on('destroyRoute', (hardDelete) => {



                this.showSelectedLocationDialog = false;
                this.drawer = false;
                this.$store.dispatch('drawer/setFormAddRoute')
                let destroyPromise = this.$store.dispatch('routes/destroy', hardDelete)
               
                this.afterRouteDestroy(destroyPromise, true);
            

                this.$store.dispatch('status/updateResources', 'routedata')


            });

            window.vm.$on('drawedited', () => {
                //console.error("########### drawedited", this.$store.getters['routes/route'])
                setRoute(
                    //this.$store.getters['routes/selectedMarker'],
                    this.$store.getters['routes/route'],
                    this.$store,
                    true
                )
            })

            window.vm.$on('openPopup', (feature) => {

                let marker = this.activeGroup.getLayer(feature.leafletid)
                if (typeof marker !== 'undefined') {
                    marker.openPopup();
                }
            })

            window.vm.$on('addMarker', () => {

                document.querySelector('.leaflet-draw-draw-marker')
                    .click();
            })


            window.vm.$on('routeAdded', () => {


                //console.log("########### routeAdded called")

                this.$store.dispatch('routes/index')
                    .then((res) => {
                        this.$store.dispatch('routes/setIsFetching', false)
                        this.$store.commit('routes/index', res.data);
                        this.$store.commit('routes/setMarkers');
                        this.initRouteMarkers();
                        this.drawer = false;
                        this.$store.dispatch('routes/flushNewRoute');
                        this.$store.dispatch('status/updateResources', 'routedata')

                    })

            });

            window.vm.$on('hideLocations', () => {

                this.$store.dispatch('drawer/setFormAddRoute');
                this.drawer = false;

                this.hideLocations();


            });

            window.vm.$on('showPrevMarker', () => {

                this.showPrevMarker();
            })


            window.vm.$on('features', () => {

                this.drawer = true;

                this.$store.dispatch('locations/setFetching', false);


                this.$forceUpdate();


                // create new group and add markers to that
                if (typeof this.locationsFeatureGroup !== 'undefined') {
                    //console.log("poista");
                    this.map.removeLayer(this.locationsFeatureGroup)
                }
                this.locationsFeatureGroup = new window.L.featureGroup();
                this.activeGroup = this.locationsFeatureGroup;
                this.map.addLayer(this.locationsFeatureGroup)


                // loppuu


            });


            delete window.L.Icon.Default.prototype._getIconUrl;

            /*L.Icon.Default.mergeOptions({
                //iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
                //iconUrl: require('leaflet/dist/images/marker-icon_route.png'),
                //shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
            });*/

            /*this.$store.dispatch('routes/index')
            .then((res) => {
                this.$store.commit('routes/index', res.data);
                this.$store.commit('routes/setMarkers');
            })*/


        },

        beforeDestroy()
        {
            this.$store.dispatch('settings/setShowOnlyHidden', false)
        },




        mounted() {

            //console.log(this.$route)
            
            this.init()
        
            


        },

        updated() {


            this.$nextTick
            (() => {


                if (!this.$store.getters['locations/locationsAdded']
                    //&& this.$store.getters['locations/hasFeatures']
                    && this.$store.getters['drawer/formEditRoute']
                    && !this.$store.getters['locations/isFetching']
                ) {
                    this.$store.dispatch('locations/setLocationsAdded', true);
                    this.$store.dispatch('routes/setUpdateLocation', false);


                    // locationsFeatureGroup hässäkkä oli tässä


                    let leafletMarkers = []
                    let locationsToLeafletMarkersMapping = {};
                    Object.keys(this.features).forEach((key) => {

                        this.features[key].forEach((feature) => {

                            //console.log("######### FEATURE", feature)
                            let latlng;
                            try{
                                latlng = new window.L.latLng(
                                    feature.location.geometry.coordinates[1],
                                    feature.location.geometry.coordinates[0]
                                );
                            } catch(latLangErr)
                            {

                            }


                            let marker = new window.L.marker(latlng, {
                                rotationAngle: feature.rotation,
                                icon: feature.location.properties.removed === true ? this.checkPointIconRemoved : this.checkPointIcon
                            });
                            marker.bindPopup(feature.location.properties.name)

                            marker.on('click', () => {


                                if (!this.editMode && !this.deleteMode) {
                                    this.showCheckpoint(feature);

                                }
                            })


                            marker.on('dragend', (e) => {

                                if (this.attachMarkerToNode) {
                                    let closestLines = this.$store.getters['lines/closestLines'];

                                    try {
                                        Object.keys(closestLines).forEach((cl) => {
                                            let closestLine = this.activeGroup.getLayer(cl);


                                            closestLines[cl].forEach((i) => {
                                                closestLine._latlngs[i] = e.target._latlng;

                                            })

                                            closestLine.redraw();
                                            this.$store.commit('lines/addRedrawnLine', closestLine);

                                            closestLines[cl].newCoords = closestLine._latlngs


                                        })

                                        this.$store.dispatch('lines/updateLinesPosAfterMarkerRemove', closestLines)



                                    } catch (err) {
                                        //console.error("hep", err)
                                    }
                                }

                            })

                            marker.on('mouseover', () => {
                                marker.openPopup();
                                this.highLightCheckPoint(feature);
                            })

                            marker.on('mouseout', () => {
                                if (this.closePopupOnMouseout) {
                                    marker.closePopup();
                                }
                            })

                            marker.on('dragstart', () => {

                                if (this.attachMarkerToNode) {
                                    this.$store.dispatch('lines/closestLines', marker).then(() => {}).catch(() => {})
                                }


                            })


                            marker.addTo(this.map)


                            if (typeof locationsToLeafletMarkersMapping[key] == 'undefined') {
                                locationsToLeafletMarkersMapping[key] = [];

                            }

                            locationsToLeafletMarkersMapping[key].push({
                                id: feature.location._id,
                                leafletid: marker._leaflet_id
                            })
                            this.locationsFeatureGroup.addLayer(marker);
                            leafletMarkers.push(marker)


                        })
                    })


                    if (Object.keys(locationsToLeafletMarkersMapping).length > 0) {
                        this.$store.dispatch('locations/mapMarkersToLeafletMarkers', locationsToLeafletMarkersMapping);
                    }

                    this.$store.commit('locations/setLeafletMarkers', leafletMarkers)

                    //console.log("####### lines", this.lines)

                    let mapLinesToPolylines = {}
                    this.lines.forEach((l) => {


                        let lineOptions = {};
                        if(l.properties.removed === true)
                        {
                            lineOptions['color'] = '#ccc'
                        }

                        let line = new window.L.polyline(l.points, lineOptions);
                        this.locationsFeatureGroup.addLayer(line);
                        line.addTo(this.map)
                        mapLinesToPolylines[l._id] = line._leaflet_id;


                    });

                    if (this.calculateLengthAutomatically) {
                        this.$store.dispatch('routes/calculateLength')
                    }

                    let draw = {marker: {guideLayers: this.guideLayer, icon: this.checkPointIcon},
                            polyline: true,
                            polygon: false,
                            rectangle: false,
                            circle: false,
                            circlemarker: false}


                    this.map.removeControl(this.drawControl);
                    this.drawControl = new window.L.Control.Draw({

                       draw,

                        edit: {
                            featureGroup: this.locationsFeatureGroup
                        },

                    });
                    if(this.hideDrawingTools){
                        draw = {...draw, polyline: false, marker: false}
                        this.drawControl = new window.L.Control.Draw({
                            edit: {
                                remove: true,
                                featureGroup: this.locationsFeatureGroup
                            },

                            draw

                            

                        })
                    }

                    this.map.addControl(this.drawControl);


                    if (Object.keys(mapLinesToPolylines).length > 0) {
                        this.$store.dispatch('lines/mapLinesToPolylines', mapLinesToPolylines);
                    }


                }

            })
        },


        watch: {
            editMode: 'setEditMode'
        },


        computed: {

                  

            editRouteView: {
                get()
                {
                    return this.$store.getters['routes/editRouteView'];
                }
            },

               

            calculateLengthAutomatically: {
                get() {
                    return this.$store.getters['routes/calculateLengthAutomatically']
                }
            },

            /*routeLength: {
                get()
                {
                    return;
                },

                set(value)
                {
                    this.$store.dispatch('routes/setRouteLength', value);
                }
            },*/

            drawLineAutomatically: {
                get() {
                    //console.log("drawLineAutomatically")
                    return this.$store.getters['lines/drawLineAutomatically'];
                }
            },

            attachMarkerToNode: {
                get() {
                    return this.$store.getters['lines/attachMarkerToNode']
                }
            },

            guideLayer:
                {
                    get() {
                        return this.$store.getters['lines/guideLayer']
                    }
                },

            translater: {
                get() {
                    return this.$store.getters['translate/translater']
                }
            },

            showEditCheckpointDialog: {
                get() {
                    return this.$store.getters['checkpoints/showEditCheckpointDialog']
                }
            },

            drawer: {
                get() {
                    return this.$store.getters['drawer/visibility']
                },

                set(v) {
                    this.$store.dispatch('drawer/toggleVisibility', v);

                    this.$nextTick(() => {
                        this.resize();

                    })
                }
            },

            markers: {
                get() {

                    let markers = this.$store.getters['routes/markers'];
                    return markers
                },


            },

            features: {
                get() {

                    return this.$store.getters['locations/features']
                },

                set(v) {
                    this.$store.commit('locations/features', v)
                }
            },

            zoom: {
                get() {

                    return this.$store.getters['routes/zoom']
                },
                set(v) {
                    this.$store.dispatch('routes/setZoom', v);
                }
            },

            center: {
                get() {
                    return this.$store.getters['routes/center'];
                },

                set(v) {
                    this.$store.dispatch('routes/setCenter', v)
                }
            },

            routeLayerGroupVisible: {
                get: function () {
                    return this.$store.getters['routes/routeLayerGroupVisible']
                },

                set: function (value) {
                    this.$store.dispatch('routes/setRouteLayerGroupVisible', value)
                }
            },

            locationLayerGroupVisible: {
                get: function () {
                    return this.$store.getters['locations/locationLayerGroupVisible'];

                    //return true;
                },

                set: function (value) {
                    this.$store.dispatch('locations/setLocationLayerGroupVisible', value)
                }
            },

            route: {
                get: function () {
                    return this.$store.getters['routes/route']
                },

                set: function (value) {

                    this.$store.dispatch('routes/route', value)
                }
            },

            showSelectedLocationDialog: {
                get: function () {
                    return this.$store.getters['locations/showSelectedLocationDialog'];
                },

                set: function (value) {

                    this.$store.dispatch('locations/setShowSelectedLocationDialog', value);
                }
            },


            matchingFocusPointsDialog: {
                get: function () {
                    let show = this.$store.getters['routes/showMatchingFocusPointsDialog']

                    return show;
                },

                set(value) {

                    this.$store.dispatch('routes/setShowMatchingFocusPointsDialog', value)


                }

            },


            lines: {
                get() {
                    return this.$store.getters['lines/lines'];
                }
            },

            isFetching: {
                get() {
                    return this.$store.getters['routes/isFetching'];
                },

                set(value) {
                    this.$store.dispatch('routes/setIsFetching', value)
                }
            }
        },


        methods: {

            updatePopupContent(route)
            {
                
                if(this.routesFeatureGroup)
                {
                   let marker = this.routesFeatureGroup.getLayer(route.leafletid)
                   if(marker)
                   {
                       marker.getPopup().setContent(route.displayName)
                   }
                }
                
            },

            setEditMode(v)
            {
                //console.log("setEditMode", v)
                this.$store.commit('routes/setEditMode', v)
            },


            init()
            {

                if(this.map)
                {
                    this.map.eachLayer(layer => {
                        if(!layer instanceof L.TileLayer)
                        {
                            this.map.removeLayer(layer)
                        }
                    });
                }

                this.$store.dispatch('routes/index')
                .then((res) => {
                    this.$store.dispatch('routes/setIsFetching', false)
                    this.$store.commit('routes/index', res.data);
                    this.$store.commit('routes/setMarkers');
                    this.$nextTick(() => {
                        if(window.localStorage.getItem('onlyHidden') == 1)
                        {
                            this.hideDrawingTools = true;
                        }
                        //console.log(L.drawLocal)
                        window.L.drawLocal.draw.toolbar.actions.text = this.translater.__('Cancel');
                        L.drawLocal.edit.toolbar.actions = {
                            cancel: {
                                text: this.translater.__('Cancel'),
                                title: this.translater.__('Cancel editing, discard all changes')
                            },

                            clearAll: {
                                title: this.translater.__('Clear all layers'),
                                text: this.translater.__('Clear All')
                            },

                            save: {
                                title: this.translater.__('Save changes'),
                                text: this.translater.__('Save')
                            }
                        };

                        L.drawLocal.draw.toolbar.buttons = {
                            marker: this.translater.__('Draw a marker', 'draw'),
                            polyline: this.translater.__('Draw a polyline', 'draw')
                        };

                        L.drawLocal.draw.handlers.marker = {

                            tooltip: {
                                start: this.translater.__('Click map to place marker', 'draw')
                            }
                        }

                        L.drawLocal.draw.handlers.polyline = {
                            tooltip: {
                                start: this.translater.__('Click to start drawing line', 'draw'),
                                end: this.translater.__('Click last point to finish line', 'draw'),
                                cont: this.translater.__('Click to continue drawing line', 'draw')
                            },
                            error: this.translater.__('Error: shape edges cannot cross!', 'draw')

                        }


                        L.drawLocal.edit.toolbar.buttons = {
                            edit: this.translater.__('Edit layers', 'drawEdit'),
                            editDisabled: this.translater.__('No layers to edit', 'drawEdit'),
                            remove: this.translater.__('Delete layers', 'drawEdit'),
                            removeDisabled: this.translater.__('No layers to delete', 'drawEdit')
                        };


                        L.drawLocal.edit.handlers = {
                            edit: {
                                tooltip: {
                                    text: this.translater.__('Drag handles or markers to edit features', 'drawEdit'),
                                    subtext: this.translater.__('Click cancel to undo changes', 'drawEdit')
                                }
                            },
                            remove: {
                                tooltip: {
                                    text: this.translater.__('Click on a feature to remove', 'drawEdit')
                                }
                            }
                        }


                        this.map = this.$refs.map.mapObject;
                        this.map.zoomControl._zoomInButton.title = this.translater.__('Zoom in', 'leaflet');
                        this.map.zoomControl._zoomOutButton.title = this.translater.__('Zoom out', 'leaflet');
                        this.map.on('zoomend', () => {
                            this.zoom = this.map.getZoom();
                        });

                        this.map.on('click', (e) => {
                            if (this.drawMode) {

                                this.$store.dispatch('routes/closestMarker', e.latlng)
                                    .then((closest) => {
                                        this.closestMarkers.push(closest)
                                    })
                                    .catch((closest) => {
                                        this.closestMarkers.push(closest)
                                    })
                            }
                        })


                        this.map.on('draw:editstart', () => {

                             if (this.$store.getters['drawer/formEditRoute']) {

                                this.$store.getters['locations/leafletMarkers'].forEach((marker) => {
                                    marker.snapediting = new window.L.Handler.MarkerSnap(this.map, marker);
                                    marker.snapediting.addGuideLayer(this.guideLayer);
                                    marker.snapediting.enable();
                                })
                            } else if(this.$store.getters['drawer/formAddRoute']) {
                                if(typeof this.$store.getters['routes/newRoute'].marker !== 'undefined')
                                {
                                    let existingRoutes = this.$store.getters['routes/index'];
                                    this.cannotMoveGroup = new window.L.featureGroup();

                                    existingRoutes.map((existing) => {
                                        //console.log(existing)
                                        return existing.leafletid
                                    }).map((id) => {
                                       
                                        return this.activeGroup.getLayer(id)
                                    }).forEach((m) => {
                                            try {
                                                let marker = new window.L.marker(m._latlng, {
                                                    rotationAngle: 0,
                                                    icon: this.routeIcon
                                                });
                                                marker.bindPopup('You are creating a new route marker, Existing markers cannot be moved at the moment')
                                                marker.on('mouseover', () => {
                                                    marker.openPopup();
                                                })
                                                this.cannotMoveGroup.addLayer(marker)
                                            } catch (err) {
                                                // nothing here
                                            }
                                    })

                                    this.cannotMoveGroup.addTo(this.map)

                                }
                            }



                            this.editMode = true;

                            //this.touchIcons = document.getElementsByClassName("leaflet-touch-icon");
                            this.$store.commit('lines/flushRedrawnLines');

                        });

                        this.map.on('draw:drawstart', (e) => {

                            if (e.layerType === 'polyline') {
                                this.closestMarkers = []
                                this.drawMode = true;
                            }
                        })

                        this.map.on('draw:drawstop', () => {
                            this.drawMode = false
                        })

                        this.map.on('draw:editstop', () => {

                            this.editMode = false;

                        });

                        this.map.on('draw:edited', (e) => {

                            if (this.$store.getters['drawer/formAddRoute']) {

                                let updatePromise = this.$store.dispatch('routes/updateMovedMarkers', e.layers);


                                updatePromise
                                    .then(() => {


                                        this.$store.dispatch('routes/index')
                                            .then((res) => {

                                                this.$store.dispatch('routes/setIsFetching', false)
                                                this.$store.commit('routes/index', res.data);
                                                this.$store.commit('routes/setMarkers');
                                                this.initRouteMarkers();
                                                this.drawer = false;
                                                //console.log("markers after move", this.$store.getters['routes/markers'])
                                                this.$store.dispatch('status/updateResources', 'routedata');
                                            })
                                    })
                                    .catch(() => {

                                    })
                            } else if (this.$store.getters['drawer/formEditRoute']) {

                                 //console.log(e.layers)

                                this.$store.dispatch('locations/updateMovedMarkers', e.layers).then(() => {
                                  
                                    //window.vm.$emit('drawedited')

                                    this.$store.dispatch('locations/findStart', e.layers).then((start) => {
                                    //console.log("###########start", start)

                                    let routeid = this.route._id;

                                    let route = this.$store.getters['routes/index'].find((r) => {
                                        return r._id == routeid;
                                    })


                                    if(route)
                                    {
                                        //route.focusPoint.coordinates = start.location.newGeometry.coordinates;
                                        //route = {...route}
                                        
                                        //this.$store.commit('routes/updateRoutePos', routeFromRoutes)

                                        let routeMarker = this.routesFeatureGroup.getLayer(route.leafletid);
                                        let latlng = new window.L.latLng(start.location.newGeometry.coordinates[1], start.location.newGeometry.coordinates[0])
                                        routeMarker.setLatLng(latlng)

                                        
                                    }

                                    window.vm.$emit('drawedited')


                                    //this.$store.dispatch('routes/updateRoutePosition', start).then((updatedRouteRes) => {



                                        


                                        // find route marker's leafletid
                                        /*let routeid = this.route._id;
                                        let routeFromMarkers = this.markers.find((m) => {
                                            return m._id == routeid
                                        })

                                        let routeFromRoutes = this.$store.getters['routes/index'].find((r) => {
                                            return r._id == routeid;
                                        })

                                        if(routeFromMarkers)
                                        {
                                            routeFromMarkers.focusPoint.coordinates = start.location.newGeometry.coordinates;
                                            routeFromMarkers = {...routeFromMarkers}

                                            this.$store.commit('routes/updateMarkerPos', routeFromMarkers)
                                        }

                                        if(routeFromRoutes)
                                        {
                                           routeFromRoutes.focusPoint.coordinates = start.location.newGeometry.coordinates;
                                           routeFromRoutes = {...routeFromRoutes}
                                           
                                           this.$store.commit('routes/updateRoutePos', routeFromRoutes)

                                           let routeMarker = this.routesFeatureGroup.getLayer(routeFromRoutes.leafletid);
                                           let latlng = new window.L.latLng(start.location.newGeometry.coordinates[1], start.location.newGeometry.coordinates[0])
                                           routeMarker.setLatLng(latlng)

                                           
                                        }*/

                                        

                                       

                                        //console.log("############routeFromMarkers", routeFromMarkers, "#################routefromroutes", routeFromRoutes, "#########start", start)
                                        //window.vm.$emit('drawedited')
                                    /*}).catch((updateRouteErr) => {
                                            
                                             window.vm.$emit('drawedited')

                                    })*/
                                }).catch(() => {
                                     window.vm.$emit('drawedited')
                                })





                                }).catch((err) => {
                                    //console.log("####### nyt tuli error")
                                    window.vm.$emit('drawedited')
                                })
                                this.$store.dispatch('status/updateResources', 'routedata');

                                //this.$store.dispatch('lines/updateMovedLines', {edited:e.layers});

                                //this.$store.dispatch('routes/calculateBounds');

                                /*this.$store.dispatch('locations/findStart', e.layers).then((start) => {
                                    console.log("###########start", start)
                                    this.$store.dispatch('routes/updateRoutePosition', start).then((updatedRouteRes) => {
                                        // find route marker's leafletid
                                        let routeid = this.route._id;
                                        let routeFromMarkers = this.markers.find((m) => {
                                            return m._id == routeid
                                        })

                                        let routeFromRoutes = this.$store.getters['routes/index'].find((r) => {
                                            return r._id == routeid;
                                        })

                                        console.log("############routeFromMarkers", routeFromMarkers, "#################routefromroutes", routeFromRoutes)

                                    }).catch((updateRouteErr) => {
                                            
                                            

                                    })
                                }).catch(() => {}) */




                            }

                        })


                        this.map.on(window.L.Draw.Event.CREATED, (e) => {

                            this.activeGroup.addLayer(e.layer)
                            if (e.layerType === 'marker') {

                                this.drawer = true;
                                if (this.$store.getters['drawer/formAddRoute']) {
                                    //this.closestMarker(e.layer)
                                    this.$store.dispatch('routes/setNewRouteMarker', e.layer);
                                    this.$store.dispatch('drawer/setHeader', 'New Route');
                                } else if (this.$store.getters['drawer/formEditRoute']) {
                                    this.$store.dispatch('locations/setNewLocationMarker', e.layer);
                                    this.$store.dispatch('locations/storeBlank')
                                        .then((blankRouteRes) => {
                                            let route = this.$store.getters['routes/route'];
                                            this.$store.dispatch('routes/addBlankLocation', {
                                                routeId: route._id,
                                                location: blankRouteRes.data

                                            })
                                                .then((addBlankLocationRes) => {

                                                    this.$store.dispatch('status/updateResources', 'routedata');

                                                    if (addBlankLocationRes.status === 200) {
                                                        if (this.drawLineAutomatically) {
                                                            this.$store.dispatch('routes/lastLocation')
                                                                .then((lastLocationRes) => {

                                                                    this.$store.dispatch('lines/insertLineAutomatically',
                                                                        {
                                                                            newMarker: blankRouteRes.data,
                                                                            secondToLast: lastLocationRes
                                                                        });
                                                                    setRoute(
                                                                        //this.$store.getters['routes/selectedMarker'],
                                                                        this.$store.getters['routes/route'],
                                                                        this.$store,
                                                                        true
                                                                    )
                                                                    //this.$store.dispatch('routes/calculateBounds');

                                                                })
                                                                .catch(() => {

                                                                    setRoute(
                                                                        //this.$store.getters['routes/selectedMarker'],
                                                                        this.$store.getters['routes/route'],
                                                                        this.$store,
                                                                        true
                                                                    )
                                                                    //this.$store.dispatch('routes/calculateBounds');
                                                                })
                                                        } else {

                                                            setRoute(
                                                                this.$store.getters['routes/route'],
                                                                this.$store,
                                                                true
                                                            )
                                                            //this.$store.dispatch('routes/calculateBounds');
                                                        }

                                                    }
                                                })
                                                .catch(() => {
                                                    //console.log(err);
                                                })


                                        })
                                        .catch(() => {
                                            //console.error("storeBlank::err", err)
                                        })


                                }

                            } else if (e.layerType === 'polyline') {
                                if (this.$store.getters['drawer/formEditRoute']) {

                                    this.$store.dispatch('lines/insert', {
                                        layer: e.layer,
                                        closestMarkers: this.closestMarkers
                                    })

                                    setRoute(
                                        this.$store.getters['routes/route'],
                                        this.$store
                                    )

                                }
                            }
                        });

                        this.map.on('draw:deletestart', () => {
                            //console.log("####### draw::deleteStart")
                            if (this.$store.getters['drawer/formAddRoute']) {
                                this.$store.dispatch('routes/disableMarkerDelete')
                                    .then((ids) => {
                                        this.cannotDeleteGroup = new window.L.featureGroup();

                                        let markers = ids.map((id) => {
                                            return this.activeGroup.getLayer(id);
                                        })

                                        markers.forEach((m) => {
                                            //this.activeGroup.removeLayer(m)
                                            //console.log(m)

                                            try {
                                                let marker = new window.L.marker(m._latlng, {
                                                    rotationAngle: m.options.rotationAngle,
                                                    icon: this.routeIcon
                                                });
                                                marker.bindPopup(this.translater.__('Marker has multiple routes in the same focus point, thus it cannot be deleted'))
                                                this.cannotDeleteGroup.addLayer(marker)
                                            } catch (err) {
                                                // nothing here
                                            }
                                            //console.log(this.map.hasLayer(marker))

                                        })

                                        this.cannotDeleteGroup.addTo(this.map)


                                    })
                            } else if (this.$store.getters['drawer/formEditRoute']) {
                                this.editMode = true
                                this.$store.dispatch('locations/disableMarkerDelete')
                                    .then((ids) => {
                                        this.cannotDeleteGroup = new window.L.featureGroup();
                                        let markers = ids.map((id) => {
                                            return this.activeGroup.getLayer(id);
                                        })

                                        markers.forEach((m) => {

                                            try {
                                                let marker = new window.L.marker(m._latlng, {
                                                    rotationAngle: m.options.rotationAngle,
                                                    icon: this.checkPointIcon
                                                });
                                                marker.bindPopup(this.translater.__('Start and finish checkpoints cannot be deleted', 'routes'))
                                                this.cannotDeleteGroup.addLayer(marker)
                                            } catch (err) {
                                                // nothing here
                                            }
                                            //console.log(this.map.hasLayer(marker))

                                        });

                                        this.cannotDeleteGroup.addTo(this.map)
                                    })

                            }

                            //console.log(this.markers)

                            this.deleteMode = true;


                        });

                        this.map.on('draw:deletestop', () => {

                            this.deleteMode = false;
                            if (typeof this.cannotDeleteGroup !== 'undefined') {
                                this.map.removeLayer(this.cannotDeleteGroup)
                            }

                            if (typeof this.cannotMoveGroup !== 'undefined') {
                                this.map.removeLayer(this.cannotMoveGroup)
                                this.cannotMoveGroup = undefined
                            }

                            this.editMode = false



                        })

                        this.map.on('draw:deleted', (e) => {
                            if (this.$store.getters['drawer/formAddRoute']) {


                                let bdPromise = this.$store.dispatch('routes/bulkDestroy', e.layers);


                                if (typeof bdPromise !== 'undefined') {
                                    this.afterRouteDestroy(bdPromise)
                                    this.$store.dispatch('status/updateResources', 'routedata')


                                }

                            } else if (this.$store.getters['drawer/formEditRoute']) {

                                let bdPromise = this.$store.dispatch('locations/bulkDestroy', e.layers);

                                //if(typeof bdPromise !== 'undefined')
                                //{
                                try {
                                    bdPromise
                                        .then((res) => {
                                            //console.log("###### locations/bulkDestroy", res.status)
                                            if (typeof res !== 'undefined' && res.status == 200) {
                                                setRoute(
                                                    this.$store.getters['routes/route'],
                                                    this.$store,
                                                    true
                                                )

                                                this.$store.dispatch('status/updateResources', 'routedata')

                                                //this.$store.dispatch('routes/calculateBounds');
                                            }

                                        }).catch((bdPromiseErr) => {
                                            console.log(bdPromiseErr)
                                        })
                                } catch (err) {
                                    //console.error(err)
                                }
                                //} else {
                                //console.error("hep")
                                //}

                                this.$store.dispatch('lines/destroy', e.layers).then((res) => {
                                    //console.log("########### LINES/DESTROY")
                                    if(res.status === 200){
                                        setRoute(
                                            this.$store.getters['routes/route'],
                                            this.$store
                                            
                                        )
                                    }
                                }).catch((linesResErr) => {
                                    console.log(linesResErr)
                                })


                            }
                        })


                        /*window.addEventListener('resize', () => {

                            /*window.clearTimeout(this.resizeMap);
                            this.resizeMap = window.setTimeout(() => {
                                this.resize();

                                //this.$forceUpdate()
                            }, 100) */
                        //})


                        this.routesFeatureGroup = new window.L.featureGroup();
                        this.activeGroup = this.routesFeatureGroup;


                        this.map.addLayer(this.routesFeatureGroup);


                        this.initRouteMarkers();


                        this.drawControl = new window.L.Control.Draw({
                            edit: {
                                featureGroup: this.routesFeatureGroup,
                                remove: true,

                            },
                            draw: {
                                marker: {
                                    icon: this.routeIcon,

                                },
                                polyline: true,
                                polygon: false,
                                rectangle: false,
                                circle: false,
                                circlemarker: false,
                                polyline: false
                            }
                        });

                        if(!this.hideDrawingTools){
                            this.map.addControl(this.drawControl)
                        }
                        //this.resize()
                        //console.log("mounted")


                    });
                });
            },

            afterRouteUpdate(flushRoute) {


                this.hideLocations(flushRoute);
                this.$store.dispatch('routes/index')
                    .then((res) => {

                        this.$store.dispatch('routes/setIsFetching', false)
                        this.$store.commit('routes/index', res.data);
                        this.$store.commit('routes/setMarkers');

                        this.initRouteMarkers();


                    })
                    .catch(() => {
                        console.log("afterRouteUpdate",err)
                    })

            },

            afterRouteDestroy(bdPromise, removeMarker) {
                let rm = false;
                if (removeMarker) {
                    rm = true;
                }
                bdPromise
                    .then((bdRes) => {
                        if (typeof bdRes !== 'undefined' && bdRes.status == 200) {

                            if (rm) {
                                this.hideLocations();

                            } else {

                                this.$store.dispatch('routes/flushRoute');
                                this.$store.dispatch('routes/flushSelectedMarker');
                                this.$store.dispatch('routes/flushSelectedLeafletMarker')
                            }
                            this.$store.dispatch('routes/index')
                                .then((res) => {

                                    this.$store.dispatch('routes/setIsFetching', false)
                                    this.$store.commit('routes/index', res.data);
                                    this.$store.commit('routes/setMarkers');

                                    this.initRouteMarkers();


                                })
                                .catch((routesIndexErr) => {
                                    console.log(routesIndexErr)
                                })
                        }

                    })
                    .catch((afterRouteDestroyErr) => {
                        console.log(afterRouteDestroyErr)
                    })
            },

            closestMarker(marker) {
                this.$store.dispatch('routes/closestMarker', marker)
                //console.log("zoom", this.zoom)
            },

            highLightCheckPoint(feature) {

                this.$store.dispatch('routes/setHighLighted', feature.location._id)
            },

            initRouteMarkers() {

                if (typeof this.routesFeatureGroup !== 'undefined') {
                    this.routesFeatureGroup.eachLayer((l) => {

                        this.routesFeatureGroup.removeLayer(l);
                    });
                } else {
                    this.routesFeatureGroup = new window.L.featureGroup();
                }


                let markersToLeafLetMapping = {}
                this.markers.forEach((m) => {
                    //console.log("############ m", m)
                    //var myIcon = L.divIcon({ popupAnchor: [0, -30] });
                    let latlng = new window.L.latLng(m.position.lat, m.position.lng)
                    let marker = new window.L.marker(latlng, {rotationAngle: m.rotationAngle, icon: m.removed === true ? this.routeIconRemoved : this.routeIcon});


                    marker.addTo(this.map)
                    this.routesFeatureGroup.addLayer(marker)
                    markersToLeafLetMapping[m._id] = marker._leaflet_id;
                    //this.$store.dispatch('routes/setMarkerLeafletId', {id:m._id, leafletid:marker._leaflet_id})


                    this.$store.dispatch('routes/matchingFocusPoints', {m: m})

                    //this.$store.dispatch('routes/matchingFocusPoints', {m: m, marker: marker})
                        .then((matchingFocusPointsRes) => {

                            this.$store.commit('routes/matchingFocusPoints', matchingFocusPointsRes);

                            let popupContent = m.displayName;

                            if (this.$store.getters['routes/matchingFocusPoints'][m._id].length > 1) {
                                popupContent = this.$store.getters['routes/matchingFocusPoints'][m._id].length.toString();

                                //popupContent = "jee"
                            }


                            marker.bindPopup(popupContent);
                            marker.on('mouseover', () => {
                                marker.openPopup();
                            })


                            marker.on('click', () => {


                                if (!this.editMode && !this.deleteMode) {
                                    //m is marker from store
                                    // marker is leaflet marker object
                                    this.markerOnClick(m, marker, this.$store)


                                }


                            })

                        })

                });

                this.$store.dispatch('routes/mapMarkersToLeafletMarkers', markersToLeafLetMapping);

                //this.$store.commit('routes/setIsUpdatingRouteGroup', false)
            },

            showPrevMarker() {

                let prevMarker = this.$store.getters['routes/selectedLeafletMarker'];

                if (typeof prevMarker !== 'undefined') {

                    this.routesFeatureGroup.addLayer(
                        prevMarker
                    )


                } else {
                    //console.error('prevMarker is null')
                }

            },

            hideLocations(flush) {
                try {

                    let f = true;
                    if (typeof flush !== 'undefined') {
                        f = flush;
                    }


                    // this might be obsolete, but needs testing
                    //this.initRouteMarkers()
                    if (typeof this.map !== 'undefined') {
                        if (typeof this.drawControl !== undefined) {
                            this.map.removeControl(this.drawControl);
                        }
                        if (typeof this.activeGroup !== 'undefined') {
                            this.map.removeLayer(this.activeGroup);
                        }
                    }

                    if (typeof this.activeGroup !== 'undefined') {


                        this.activeGroup = this.routesFeatureGroup;
                        this.drawControl = new window.L.Control.Draw({
                            edit: {
                                featureGroup: this.activeGroup
                            },
                            draw: {
                                marker: {
                                    icon: this.routeIcon,

                                },
                                polyline: true,
                                polygon: false,
                                rectangle: false,
                                circle: false,
                                circlemarker: false,
                                polyline: false
                            }
                        });
                        if(!this.hideDrawingTools){
                            this.map.addControl(this.drawControl)
                        }
                    }
                    if (f) {

                        this.$store.dispatch('routes/flushRoute');
                        this.$store.dispatch('routes/flushSelectedMarker');
                        this.$store.dispatch('routes/flushSelectedLeafletMarker')
                    }
                } catch (err) {
                    //console.error("###### hideLocations", err)
                }


            },

            markerOnClick(m) {


                this.showPrevMarker();

                //


                // prevmarker is not null,
                // show it, if other one is clicked

                // set selected marker
                this.$store.dispatch('routes/setSelectedMarker', m)
                // check if the selected marker has other markers with matching focuspoints

                // we need to save the selected leaflet marker also
                //
                // if there are matching focuspoints, show the dialog


                //this.$store.dispatch('routes/matchingFocusPoints', {m: m, marker: marker})

                this.$store.dispatch('routes/matchingFocusPoints', {m})

                    .then((matchingForusPointsRes) => {
                        this.$store.commit('routes/matchingFocusPoints', matchingForusPointsRes);
                        if (this.$store.getters['routes/matchingFocusPoints'][m._id].length > 1) {
                            this.matchingFocusPointsDialog = true;
                        } else { // if there are no matching focuspoints

                            //this.routesFeatureGroup.removeLayer(marker)
                            //this.$store.dispatch('routes/setSelectedLeafletMarker', marker);
                            setRoute(m, this.$store)

                        }
                    })


            },

            resize() {

                this.map.invalidateSize();
            },


            /*showCheckpoint(f) {

                this.$store.dispatch('locations/setLocation', f)
                //let replaceIndex = undefined;
                this.$store.dispatch('breadcrumbs/addItem', {text: f.location.properties.name, type: 'location'})

                this.showSelectedLocationDialog = true;
                //this.initRouteMarkers();


            },*/

            showCheckpoint(f)
            {
                if(this.editRouteView === 2)
                {
                    this.$scrollTo(`#routes${f.location._id}`)
                }
            },

            focusRoute(m) {


                this.center = m.position;
                //this.zoom = 16;
                if (!this.locationLayerGroupVisible) {
                    this.locationLayerGroupVisible = true
                }
                //this.routeLayerGroupVisible = false
                this.$store.dispatch('locations/features', m._id);


            },


            // deprecated ? - Needs testing
            /*showRoutesWithMatchingFocusPoints(m, marker)
            {
                if(!this.editMode){

                    this.showPrevMarker();
                    this.$store.dispatch('routes/setSelectedMarker', m)
                    this.$store.dispatch('routes/matchingFocusPoints', {m: m, marker: marker});




                    this.$store.dispatch('routes/setSelectedLeafletMarker', marker);

                }
            } */
        }


    }
</script>

<style>

    @import "~leaflet-draw/dist/leaflet.draw.css";
    @import "~leaflet/dist/leaflet.css";


    .container {
        height: 100%;
    }

    .leaflet-container {
        background-color: rgba(255, 0, 0, 0.0);
    }


    body {
        padding: 0;
        margin: 0;
    }

    html, body, .rn-map-container {
        height: 100%;
        width: 100%;

    }


    #rn-navigation-drawer {
        height: auto;
        /*width:10%; */
        float: left;
    }


</style>
